import { formatDateTime } from "$utils/utils";

export const isJsons = (array) =>
  Array.isArray(array) &&
  array.every((row) => typeof row === "object" && !(row instanceof Array));

export const jsonsHeaders = (array) =>
  Array.from(
    array
      .map((json) => Object.keys(json))
      .reduce((a, b) => new Set([...a, ...b]), [])
  );

export const getHeaderValue = (property, obj) => {
  const foundValue = property
    .replace(/\[([^\]]+)]/g, ".$1")
    .split(".")

    .reduce((o, p, i, arr) => {
      // if at any point the nested keys passed do not exist, splice the array so it doesnt keep reducing
      const value = o[p];
      if (value === undefined || value === null) {
        arr.splice(1);
      } else {
        return value;
      }
    }, obj);
  // if at any point the nested keys passed do not exist then looks for key `property` in object obj
  return foundValue === undefined
    ? property in obj
      ? obj[property]
      : ""
    : foundValue;
};

export const jsons2arrays = (jsons, headers) => {
  headers = headers || jsonsHeaders(jsons);

  // allow headers to have custom labels, defaulting to having the header data key be the label
  let headerLabels = headers;
  const headerKeys = headers;
  if (isJsons(headers)) {
    headerLabels = headers.map((header) => header.label);
    // headerKeys = headers.map((header) => header.key);
    // IF I DO THE VALUE EXTRACT HERE I SHOULD BE OK
  }

  const data = jsons.map(
    (object) => headerKeys.map((header) => header.key(object)) // getHeaderValue(header, object))
  );
  return [headerLabels, ...data];
};

export const elementOrEmpty = (element) =>
  typeof element === "undefined" || element === null ? "" : element;

export const joiner = (data, separator = ",", enclosingCharacter = '"') => {
  return data
    .filter((e) => e)
    .map((row) =>
      row
        .map((element) => elementOrEmpty(element))
        .map((column) => `${enclosingCharacter}${column}${enclosingCharacter}`)
        .join(separator)
    )
    .join(`\n`);
};

export const jsons2csv = (data, headers, separator, enclosingCharacter) =>
  joiner(jsons2arrays(data, headers), separator, enclosingCharacter);

export const downloadFile = async (
  response: any,
  fileName: string,
  ext = "csv",
  appendDate?: boolean
) => {
  if (response) {
    let blob = response?.size > 0 ? response : await response?.blob();

    // Ajout du BOM (byte order mark) pour l'encodage UTF-8 pour le type csv uniquement
    if (ext === "csv") {
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const fileContent = await blob.text();
      blob = new Blob([bom, fileContent], { type: blob.type });
    }

    const file = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = file;

    let finalFileName = `${formatDateTime()}.${ext}`;
    let parsedFileName = fileName.replace(/"/g, "");
    const hasAlreadyExt = parsedFileName.split(`.${ext}`)[1] === "";
    if (hasAlreadyExt) {
      parsedFileName = parsedFileName.replace(`.${ext}`, "");
    }
    if (parsedFileName && parsedFileName.length > 0) {
      finalFileName = `${parsedFileName}${
        appendDate ? `-${formatDateTime()}` : ""
      }.${ext}`;
    }
    a.download = finalFileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
  }
};
